import React, { useState, useEffect, useCallback } from 'react'
import api from '../api'

import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined, KeyOutlined } from '@ant-design/icons'
import { Button, Tag, Typography, message, Modal, Input, Table, Tooltip, Space, Alert, Image, Checkbox } from 'antd'

import { ProCard, CheckCard } from '@ant-design/pro-components'
import { name } from 'file-loader'

import Wxpay from '../../images/wxpay.png'

const { Paragraph, Text } = Typography


// let prices = {
//     ['A']: 29,
//     ['B']: 80,
//     ['C']: 220,
// }


//  控制台-会员中心
function Member(props) {
    const [data, setData] = useState({ gip: [], token: '', member: '普通', ServerData: { ip: null, port: null }, group_id: null, MemberData: { ay: {} }, nzadmin: 0 })
    const [update, setUpdate] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [details, setDetails] = useState({ modal: null, total_fee: null, qr: null, port: '40268' })
    const [loading, setLoading] = useState(false)

    const [payment, setPayment] = useState(false)
    const [paymentData, setPaymentData] = useState({})

    useEffect(() => {
        let name = 'userMemberData'
        // if (localStorage.getItem(name)) {
        //     setData(JSON.parse(localStorage.getItem(name)))
        // }

        api.get('/api/v2/user/get', {
            params: {
                name: 'member'
            }
        })
            .then((res) => {
                if (res.data.code === 200) {
                    let Data = res.data.data.data.Data
                    localStorage.setItem(name, JSON.stringify(Data))

                    console.log(Data.MemberData);

                    setData(Data)
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [update])

    const resetToken = useCallback(() => {
        api.post('/api/v2/user/update', {
            type: 'gtoken',
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setUpdate(Date.now())
                    message.success('已重置Token,请更新使用旧的Token的插件')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [])


    //  取消绑定
    function unbind() {
        api.post('/api/v2/user/update', {
            type: 'unbind',
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setUpdate(Date.now())
                    message.success('已取消绑定,可以绑定其他的设备了')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }


    const showModal = () => {
        setIsModalOpen(true)
    }

    const handleOk = useCallback(() => {
        let Data = []

        for (let i = 0; i < data.gip.length; i++) {
            if (data.gip[i].length >= 1) {
                if (!validateIP(data.gip[i])) {
                    if (!validateDomain(data.gip[i])) {
                        message.warning('请检查是否有正确输入IP/域名')
                        return
                    }
                }
                Data.push(data.gip[i])
            }
        }
        setIsModalOpen(false)
        api.post('/api/v2/user/update', {
            type: 'gip',
            value: Data
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setUpdate(Date.now())
                    message.success('修改成功')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [data])

    const handleCancel = () => {
        setIsModalOpen(false)
    }

    const onChange = (e) => {
        let name = parseInt(e.target.name)
        let value = e.target.value

        setData((data) => ({
            ...data,
            gip: [
                ...data.gip.slice(0, name),
                value,
                ...data.gip.slice(name + 1)
            ]
        }))
    }

    /*  检查ip地址 0.0.0.0~255.255.255.255  */
    function validateIP(str) {
        var re =
            /^(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|[0-9])\.((1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.){2}(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/
        return re.test(str)
    }

    // 检查域名
    function validateDomain(str) {
        var re =
            /^([0-9a-zA-Z-]{1,}\.)+([a-zA-Z]{2,})$/
        return re.test(str)
    }

    //  操作
    function onClick(name) {
        if (name === 'Regenerate_APIKeys') {
            api.post('/api/v2/user/update', {
                type: 'Regenerate_APIKeys',
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        setUpdate(Date.now())
                        message.success('重置成功, 请刷新页面查看!')
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                })
        }

        if (name === 'Create_APIKeys') {
            api.post('/api/v2/user/update', {
                type: 'Create_APIKeys',
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        setUpdate(Date.now())
                        message.success('创建成功, 请刷新页面查看!')
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                })
        }
    }

    //  处理会员渲染显示
    function getMember(value, time) {
        if (time) {
            if (data.member !== 'user') {
                if (value) {
                    if (data.expired) {
                        return '已过期'
                    }
                    return value
                }
                return '永不过期'
            }

            return '永不过期'
        }

        if (value === 'nv1') {
            return 'NV1会员'
        }
        if (value === 'nv2') {
            return 'NV2会员'
        }
        if (value === 'nv3') {
            return 'NV3会员'
        }
        return '普通'
    }


    return (
        <div>
            <div style={{ marginBottom: 20 }}>
                {/* <Alert message="目前已暂停所有会员的购买/续费操作, 请耐心等待官方维护完成并通知。" type="error" /> */}

                <Alert
                    message="暂停业务"
                    description="目前已暂停所有会员的购买/续费操作, 请耐心等待官方维护完成并通知。"
                    type="warning"
                    showIcon
                />
            </div>

            <ProCard title={<Text>会员信息</Text>} style={{ borderColor: '#313131', backgroundColor: '#141414', color: '#fff', maxWidth: 300, float: 'left', marginRight: 20 }} bordered headerBordered>
                {/* 等级: {data.member === 'nv1' ? <>{getMember()} 会员 {data.expired ? <Tag color="error">已过期</Tag> : null}</> : '普通'} */}
                等级: {getMember(data.member)}
                <br />
                状态:   {data.expired ? data.member !== 'user' ? <Tag color="error">已过期</Tag> : <Tag color="success">正常</Tag> : <Tag color="success">正常</Tag>}
                <br />
                过期时间: {getMember(data.etime, true)}
                <br />
            </ProCard>

            <ProCard title={<Text>访问控制</Text>} style={{ borderColor: '#313131', backgroundColor: '#141414', color: '#fff', maxWidth: (Math.floor(props.state.width * 0.6) - 200) - 380, float: 'left' }} bordered headerBordered>
                <div style={{ marginBottom: 20 }}>
                    <Alert
                        message="即将下线"
                        description="正在逐渐关闭此Token功能, 请更新资源并使用下方的API Key"
                        type="warning"
                        showIcon
                    />
                </div>

                <Paragraph
                    copyable={{
                        text: `${data.token}`,
                    }}
                    style={{ marginBottom: 0 }}
                >
                    Token: {data.token}
                </Paragraph>
                IP: {
                    data.gip.map((item, index) => (
                        <Tag color="default" key={index}>{item}</Tag>
                    ))
                }
                <br />
                允许绑定IP数量: <Tag color="processing">2</Tag>
                <br />
                <Button size='small' style={{ float: 'right' }} onClick={showModal}>编辑IP</Button>
                <Button type="primary" size='small' style={{ float: 'right', marginRight: 10 }} onClick={resetToken}>重置Token</Button>


            </ProCard>

            <ProCard title={<Text>API Key 管理</Text>} style={{ borderColor: '#313131', backgroundColor: '#141414', color: '#fff', maxWidth: '100%', float: 'left', marginTop: 20 }} bordered headerBordered>
                <Text>一般用于涉及到N2YUN服务的产品, 建议每隔一段时间进行更新密钥信息, 最大程度保护您的账户安全!</Text>
                {data.apikeys ? <>
                    <div style={{ marginTop: 20 }}>API ID: {data.apikeys.api_id}</div>
                    <div>API Key: {data.apikeys.api_key}</div>

                    <Button size='small' style={{ marginTop: 20 }} onClick={() => { onClick('Regenerate_APIKeys') }}><SyncOutlined /> 重新生成 API Key</Button>


                </> : <>
                    <div>目前未生成, 请手动点击下方 [生成 API Keys 信息] 生成一下!</div>

                    <Button size='small' style={{ marginTop: 20 }} onClick={() => { onClick('Create_APIKeys') }}><KeyOutlined /> 生成 API Keys 信息</Button>

                </>}
            </ProCard>


            <ProCard title={<Text>NZ-admin 绑定信息</Text>} style={{ borderColor: '#313131', backgroundColor: '#141414', color: '#fff', maxWidth: '100%', float: 'left', marginTop: 20 }} bordered headerBordered>
                绑定状态: {data.server ? <Tag color="success">已绑定</Tag> : <Tag color="error">未绑定</Tag>}
                <br />
                <Button type="primary" size='small' style={{ float: 'right' }} onClick={unbind}>取消绑定</Button>
            </ProCard>


            <Modal title="编辑IP" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Input placeholder="IP-1" style={{ marginTop: 10 }} name='0' onChange={onChange} value={data.gip[0]} />
                <Input placeholder="IP-2" style={{ marginTop: 10 }} name='1' onChange={onChange} value={data.gip[1]} />
            </Modal>


            <props.clear />

        </div>
    )
}

export default Member;